import { Link } from "react-router-dom";

import Summary from "./Summary";
import CCard from "./CCard";

const HomeTop = ({ details }) => {
	return (
		<>
			<p>
				Use this area to manage your JW Marriott room night occupants or to
				request additional nights.
			</p>

			<p>
				Should you have any questions or room upgrade requests, please email
				Samantha Murray at{" "}
				<a href="mailto:valerobfc@valero.com">valerobfc@valero.com</a>. Do NOT
				call the hotel directly; they will not be able to assist you.
			</p>

			<p>
				All hotel reservations must be submitted by <strong>March 6th</strong>.
				Any changes submitted after this date will be subject to approval based
				on availability.
			</p>

			<p>
				Note that if you need to request non-sequential nights, please submit
				them as separate requests.
			</p>

			<p>
				<strong>
					Please note that there is a 7-day cancellation policy. Any
					cancellations within 7 days will be subject to one (1) night of room
					charges.
				</strong>
			</p>

			<CCard data={details.stripe} />

			{details.totalSpots > 0 && (
				<Summary
					data={{
						wed: details.nights0.val3,
						thu: details.nights1.val3,
						fri: details.nights2.val3,
						sat: details.nights3.val3,
						sun: details.nights4.val3,
					}}
				/>
			)}

			<div
				className="flex-container2"
				style={{
					marginTop: "10px",
				}}
			>
				<div
					className="homebutton"
					style={{
						marginRight: "0",
						width: "100%",
						whiteSpace: "nowrap",
						display:
							details.registrationId === 25425 ||
							details.registrationId === 26059
								? "block"
								: details.levelId === "diamondsponsor" ||
								  details.levelId === "goldsponsor" ||
								  details.levelId === "silversponsor" ||
								  details.levelId === "recognitionsponsor"
								? "none"
								: "block",
					}}
				>
					<Link to="/dashboard/hotel/jw">
						<i className="fa fa-building-o"></i> &nbsp;&nbsp;Add a New Occupant
						at the JW Marriott
						<i className="fa fa-angle-right"></i>
					</Link>
				</div>

				{/*<div
					className="homebutton"
					style={{
						width: "100%",
						whiteSpace: "nowrap",
					}}
				>
					<Link to="/dashboard/hotel/other">
						<i className="fa fa-building-o"></i> &nbsp;&nbsp;Add a New Occupant
						at the La Cantera
						<i className="fa fa-angle-right"></i>
					</Link>
				</div>*/}
			</div>
		</>
	);
};

export default HomeTop;
